<template>
  <svg
    t="1648891657494"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4806"
    width="200"
    height="200"
  >
    <path
      d="M151.4 384.7L476.6 710c19.5 19.5 51.2 19.5 70.7 0l325.3-325.3c19.5-19.5 19.5-51.2 0-70.7s-51.2-19.5-70.7 0L512 603.9 222.1 314c-19.5-19.5-51.2-19.5-70.7 0-19.6 19.5-19.6 51.2 0 70.7z"
      p-id="4807"
      :fill="color"
    ></path>
  </svg>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class ArrowsIcon extends Vue {
  @Prop({ type: String, default: '#d3d3d3' }) color: string;
}
</script>
